<section id="foundations-endowments">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h1>History of Changes</h1>
      </div>
    </div>
  </div>
</section>

<section class="section">
  <div class="container">
    <div class="row">
      <div class="col-lg-3">
        <div class="btn-group mb-3 dropdown">
          <button id="button-animated" type="button" class="btn btn-info dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
            Other Disclosures
          </button>
          <ul class="dropdown-menu" aria-labelledby="button-animated">
            <li><a class="dropdown-item" href="/disclosures/index-data">IFC Indexes Data Sources</a></li>
            <li><a class="dropdown-item" href="https://www.adviserinfo.sec.gov/IAPD/IAPDFirmSummary.aspx?ORG_PK=109143" target="_blank">Form ADV</a></li>
            <!-- <li><a class="dropdown-item" href="/disclosures/history">History of Changes</a></li> -->
            <li><a class="dropdown-item" href="https://www.ifa.com/pdfs/privacypolicy.pdf" target="_blank">Privacy Policy</a></li>
          </ul>
        </div>
      </div>
      <div class="col-lg-9">
        @if (history) {
          <div [innerHtml]="history[0].html | safe: 'html'"></div>
        }
      </div>
    </div>
  </div>
</section>